/**
 * @flow
 * @relayHash 329771408f63f3b848a0baf52d2e6933
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
export type UserEventVisibility = "HIDDEN" | "SHOW" | "%future added value";
export type UpdateUserEventInput = {
  clientMutationId?: ?string,
  id: string,
  booking_status?: ?BookingStatus,
  referral_source?: ?string,
  notes?: ?string,
  visibility?: ?UserEventVisibility,
};
export type BookingStatus_UpdateUserEventMutationVariables = {|
  input: UpdateUserEventInput
|};
export type BookingStatus_UpdateUserEventMutationResponse = {|
  +updateUserEvent: ?{|
    +user_event: ?{|
      +booking_status: ?BookingStatus,
      +visibility: ?UserEventVisibility,
    |}
  |}
|};
export type BookingStatus_UpdateUserEventMutation = {|
  variables: BookingStatus_UpdateUserEventMutationVariables,
  response: BookingStatus_UpdateUserEventMutationResponse,
|};
*/


/*
mutation BookingStatus_UpdateUserEventMutation(
  $input: UpdateUserEventInput!
) {
  updateUserEvent(input: $input) {
    user_event {
      booking_status
      visibility
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserEventInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateUserEventInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "booking_status",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "visibility",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "BookingStatus_UpdateUserEventMutation",
  "id": null,
  "text": "mutation BookingStatus_UpdateUserEventMutation(\n  $input: UpdateUserEventInput!\n) {\n  updateUserEvent(input: $input) {\n    user_event {\n      booking_status\n      visibility\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "BookingStatus_UpdateUserEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateUserEvent",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateUserEventPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEvent",
            "plural": false,
            "selections": [
              v2,
              v3
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "BookingStatus_UpdateUserEventMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateUserEvent",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateUserEventPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event",
            "storageKey": null,
            "args": null,
            "concreteType": "UserEvent",
            "plural": false,
            "selections": [
              v2,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ee14a63a6422ba654cfc532192e935fb';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/__generated__/BookingStatus_UpdateUserEventMutation.graphql.js